/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleDiagnosticsControllerLookupEmsEntitlementQueryResponse, TrimbleDiagnosticsControllerLookupEmsEntitlementPathParams, TrimbleDiagnosticsControllerLookupEmsEntitlement400, TrimbleDiagnosticsControllerLookupEmsEntitlement401, TrimbleDiagnosticsControllerLookupEmsEntitlement403, TrimbleDiagnosticsControllerLookupEmsEntitlement404 } from "../../models/trimbleDiagnosticsController/TrimbleDiagnosticsControllerLookupEmsEntitlement";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trimbleDiagnosticsControllerLookupEmsEntitlement } from "../../clients/trimble-diagnosticsService/trimbleDiagnosticsControllerLookupEmsEntitlement";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trimbleDiagnosticsControllerLookupEmsEntitlementQueryKey = (cdhAccountId: TrimbleDiagnosticsControllerLookupEmsEntitlementPathParams["cdhAccountId"]) => [{
  url: '/api/v1/trimble-ems-diagnostics/:cdhAccountId',
  params: {
    cdhAccountId: cdhAccountId
  }
}] as const;
export type TrimbleDiagnosticsControllerLookupEmsEntitlementQueryKey = ReturnType<typeof trimbleDiagnosticsControllerLookupEmsEntitlementQueryKey>;
export function trimbleDiagnosticsControllerLookupEmsEntitlementQueryOptions(cdhAccountId: TrimbleDiagnosticsControllerLookupEmsEntitlementPathParams["cdhAccountId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trimbleDiagnosticsControllerLookupEmsEntitlementQueryKey(cdhAccountId);
  return queryOptions<TrimbleDiagnosticsControllerLookupEmsEntitlementQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupEmsEntitlement400 | TrimbleDiagnosticsControllerLookupEmsEntitlement401 | TrimbleDiagnosticsControllerLookupEmsEntitlement403 | TrimbleDiagnosticsControllerLookupEmsEntitlement404>, TrimbleDiagnosticsControllerLookupEmsEntitlementQueryResponse, typeof queryKey>({
    enabled: !!cdhAccountId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trimbleDiagnosticsControllerLookupEmsEntitlement(cdhAccountId, config);
    }
  });
}

/**
 * @summary Check the EMS entitlement for a Trimble CDH account
 * {@link /api/v1/trimble-ems-diagnostics/:cdhAccountId}
 */
export function useTrimbleDiagnosticsControllerLookupEmsEntitlement<TData = TrimbleDiagnosticsControllerLookupEmsEntitlementQueryResponse, TQueryData = TrimbleDiagnosticsControllerLookupEmsEntitlementQueryResponse, TQueryKey extends QueryKey = TrimbleDiagnosticsControllerLookupEmsEntitlementQueryKey>(cdhAccountId: TrimbleDiagnosticsControllerLookupEmsEntitlementPathParams["cdhAccountId"], options: {
  query?: Partial<QueryObserverOptions<TrimbleDiagnosticsControllerLookupEmsEntitlementQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupEmsEntitlement400 | TrimbleDiagnosticsControllerLookupEmsEntitlement401 | TrimbleDiagnosticsControllerLookupEmsEntitlement403 | TrimbleDiagnosticsControllerLookupEmsEntitlement404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trimbleDiagnosticsControllerLookupEmsEntitlementQueryKey(cdhAccountId);
  const query = useQuery({
    ...trimbleDiagnosticsControllerLookupEmsEntitlementQueryOptions(cdhAccountId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupEmsEntitlement400 | TrimbleDiagnosticsControllerLookupEmsEntitlement401 | TrimbleDiagnosticsControllerLookupEmsEntitlement403 | TrimbleDiagnosticsControllerLookupEmsEntitlement404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}